import React from "react";

export default {

    licenseKeyJwPlay: 'ITWMv7t88JGzI0xPwW8I0+LveiXX9SWbfdmt0ArUSyc',
    playerScriptJwPlay: '/js/jwplayer.js',
    USER_TOKEN: 'X-Auth-Token',
    USER: 'User',
    THEME_COLOR: 'Theme-Color',
    LIMIT: 20,
    debounceTimeout: 200,

    homeStorage: 'home-storage',
    menuStorage: 'menu-storage',
    configStorage: 'config-storage',
    likeVideoStorage: 'like-video',
    pageName: 'funlove',
    domainPage: 'https://funlove.info/'
}
